import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const IsomorphicGraphsModule = () => (
  <DMModuleSubtopic
    title="Isomorphic Graphs"
    videos={[
      "https://www.youtube.com/embed/44ZPS0r5lNw"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Explain isomorphism of graphs and verify whether the following 2 graphs G and G' are isomorphic. If so, exhibit an isomorphism between them.",
        image:"/dm_33.png"
      },
      {image:"/dm_34.png"},
    ]}
    exampleVideos={[]}
  />
);

export default IsomorphicGraphsModule;
